import React, { useState } from 'react';
import { TrendingUp, TrendingDown, Info } from 'lucide-react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';

const KpiCard = ({ title, value, previousValue, sparklineData, loading, onClick, info, changeLabel }) => {
  const [showInfo, setShowInfo] = useState(false);

  if (loading) {
    return (
      <div className="bi-kpi-card">
        <div className="bi-kpi-skeleton" />
      </div>
    );
  }

  const change = previousValue
    ? (((value - previousValue) / previousValue) * 100).toFixed(1)
    : null;
  const isPositive = change !== null && parseFloat(change) >= 0;

  return (
    <div className="bi-kpi-card" onClick={onClick} role={onClick ? 'button' : undefined}>
      <div className="bi-kpi-header">
        <div className="bi-kpi-label">{title}</div>
        {info && (
          <div
            className="bi-kpi-info"
            onMouseEnter={() => setShowInfo(true)}
            onMouseLeave={() => setShowInfo(false)}
          >
            <Info size={13} />
            {showInfo && <div className="bi-kpi-tooltip">{info}</div>}
          </div>
        )}
      </div>
      <div className="bi-kpi-value">{typeof value === 'number' ? value.toLocaleString() : value}</div>
      {change !== null && (
        <div className={`bi-kpi-change ${isPositive ? 'positive' : 'negative'}`}>
          {isPositive ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
          <span>
            {isPositive ? '+' : ''}{change}%
            {changeLabel && <span className="bi-kpi-change-label"> {changeLabel}</span>}
          </span>
        </div>
      )}
      {sparklineData && sparklineData.length > 0 && (
        <div className="bi-kpi-sparkline">
          <ResponsiveContainer width="100%" height={32}>
            <LineChart data={sparklineData}>
              <Line
                type="monotone"
                dataKey="value"
                stroke={isPositive ? 'var(--admin-success)' : 'var(--admin-error)'}
                strokeWidth={1.5}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default KpiCard;
